import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressItemComponent} from './components';
import {ProgressBarComponent} from './progress-bar.component';
import {RouterModule} from '@angular/router';
import {AlertIconModule, LockerModule} from '..';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [ProgressBarComponent, ProgressItemComponent],
  imports: [CommonModule, RouterModule, AlertIconModule, LockerModule, TranslateModule],
  exports: [ProgressBarComponent],
})
export class ProgressBarModule {
}
